/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/**
 * Contains the selectors that select state from the 'OnlineCategories' store object.
 * @namespace OnlineCategoriesSelectors
 */
export default class selectors {
  /**
   * @private
   */
  static moduleIdentifier = 'UAOnlineCategories';

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof OnlineCategoriesSelectors
   */
  static fetchSdOnlineCategories = state =>
    state[selectors.moduleIdentifier].fetchSdOnlineCategories.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof OnlineCategoriesSelectors
   */
  static isFetchingFetchSdOnlineCategories = state =>
    state[selectors.moduleIdentifier].isFetchingFetchSdOnlineCategories.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof OnlineCategoriesSelectors
   */
  static fetchSdOnlineCategoriesError = state =>
    state[selectors.moduleIdentifier].fetchSdOnlineCategoriesError.payload;
}
